import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import CreateTournament from '../views/CreateTournament.vue'
import TournamentDetail from '../views/TournamentDetail.vue'
// import { authGuard } from '../auth/authGuard'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
      noMenu: true
    }
  },
  {
    path: '/create',
    name: 'CreateTournament',
    component: CreateTournament,
    meta: {
      auth: true
    }
  },
  {
    path: '/tournaments/:tournament_id',
    name: 'TournamentDetail',
    component: TournamentDetail,
    meta: {
      auth: true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(authGuard);

export default router
